import { useRef, useEffect } from "react";
import { cn } from "@/lib/utils";
import { useContent } from "@/contexts/ContentContext";

export function Editable({ path, tag = "span", className, testId }) {
  const { editMode, setPath, getByPath } = useContent();
  const ref = useRef(null);
  const value = getByPath(path);

  useEffect(() => {
    if (ref.current && ref.current.textContent !== (value ?? "")) {
      ref.current.textContent = value ?? "";
    }
  }, [value]);

  const Tag = tag;
  return (
    <Tag
      ref={ref}
      className={cn("editable", className)}
      contentEditable={editMode}
      suppressContentEditableWarning
      data-testid={testId || `editable-${path}`}
      onBlur={(e) => {
        const next = e.currentTarget.textContent.trim();
        if (next !== value) setPath(path, next);
      }}
    >
      {value}
    </Tag>
  );
}
